import { FC } from 'react';

import DataTablePagination from 'modules/_shared/components/Tables/DataTablePagination';

import { useHoldingClassListPage } from '../context/HoldingClassListPageContext';
import HoldingClassTable from './HoldingClassTable';

const HoldingClassListPageBody: FC = () => {
  const { data, actions } = useHoldingClassListPage();

  const showPagination =
    data.holdingClasses && data.holdingClassesTotal > (data.rowsPerPage || 10);

  return (
    <div className="nk-block">
      <HoldingClassTable />

      {showPagination && (
        <DataTablePagination
          className="border-0"
          itemPerPage={data.rowsPerPage || 10}
          totalItems={data.holdingClassesTotal || 0}
          paginate={actions.handleChangePage}
          currentPage={data.page}
          onChangeRowsPerPage={actions.handleChangeRowsPerPage}
          customItemPerPage={0}
          setRowsPerPage={() => {}}
        />
      )}
    </div>
  );
};

export default HoldingClassListPageBody;
